const KEY = {
  ESCAPE: 'Escape',
  TAB: 'Tab',
};

export default KEY;
